import { BasicUser } from "types/topicflow";

import { TeamPickerTeam } from "../../team-picker";

export enum TrendReportFilterType {
  TEAM = "team",
  MANAGER = "manager",
}

export type TrendReportFilterItem =
  | {
      type: TrendReportFilterType.TEAM;
      data: TeamPickerTeam[];
    }
  | {
      type: TrendReportFilterType.MANAGER;
      data: BasicUser[];
    };
